import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "fs-5 text-gray-700 mb-8" }, " TekPanel; restoran, kafe ve tüm yeme-içme işletmeleri için geliştirilmiş bir yönetim panelidir. Yemeksepeti, Getir, Trendyol Yemek ve Migros Yemek hesaplarınızı tek bir ekrandan yönetir; ürün, fiyat ve mağaza durumunuzu saniyeler içinde güncellersiniz. ", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h4", { class: "fw-bold text-dark mb-4" }, "Özellikler", -1)
const _hoisted_3 = { class: "row g-4 mb-8" }
const _hoisted_4 = { class: "d-flex align-items-start" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-vertical h-40px bg-primary me-4" }, null, -1)
const _hoisted_6 = { class: "fw-bold text-dark fs-6" }
const _hoisted_7 = { class: "text-gray-600 fs-7" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h4", { class: "fw-bold text-dark mb-3" }, "Desteklenen platformlar", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-700 mb-8" }, " Yemeksepeti · Getir · Trendyol Yemek · Migros Yemek ", -1)
const _hoisted_10 = { class: "d-flex flex-wrap gap-3" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Giriş Yap")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Bize Ulaşın")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PublicPage = _resolveComponent("PublicPage")!

  return (_openBlock(), _createBlock(_component_PublicPage, {
    title: "TekPanel",
    subtitle: "Tüm online sipariş platformlarınızı tek panelden yönetin."
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.features, (f) => {
          return (_openBlock(), _createElementBlock("div", {
            key: f.title,
            class: "col-md-6"
          }, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_6, _toDisplayString(f.title), 1),
                _createElementVNode("div", _hoisted_7, _toDisplayString(f.desc), 1)
              ])
            ])
          ]))
        }), 128))
      ]),
      _hoisted_8,
      _hoisted_9,
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_router_link, {
          to: "/sign-in",
          class: "btn btn-primary"
        }, {
          default: _withCtx(() => [
            _hoisted_11
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/destek",
          class: "btn btn-light-primary"
        }, {
          default: _withCtx(() => [
            _hoisted_12
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}